
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 26","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.502 4.45A11.866 11.866 0 0012.05.947C5.464.947.102 6.305.1 12.89c0 2.105.549 4.16 1.595 5.972L0 25.053l6.335-1.66a11.929 11.929 0 005.71 1.453h.006c6.585 0 11.946-5.359 11.949-11.946 0-3.192-1.24-6.193-3.497-8.451l-.001.001zM12.05 22.83h-.004c-1.783 0-3.531-.48-5.055-1.384l-.364-.216-3.759.986 1.004-3.663-.236-.376a9.906 9.906 0 01-1.519-5.283c.003-5.474 4.457-9.928 9.936-9.928a9.864 9.864 0 017.022 2.912 9.865 9.865 0 012.906 7.024c-.003 5.475-4.457 9.929-9.931 9.929v-.001zm5.447-7.436c-.3-.15-1.766-.872-2.04-.971-.274-.1-.473-.15-.673.149-.2.299-.771.97-.945 1.17-.173.2-.348.224-.647.075-.3-.149-1.261-.464-2.402-1.482-.887-.79-1.487-1.769-1.66-2.068-.174-.299-.02-.46.13-.609.135-.134.3-.348.449-.523.149-.175.2-.3.299-.499.1-.199.049-.372-.025-.523-.075-.149-.672-1.618-.92-2.217-.242-.581-.49-.502-.672-.512-.174-.008-.373-.01-.573-.01-.2 0-.523.074-.796.372s-1.045 1.02-1.045 2.49c0 1.47 1.07 2.889 1.22 3.087.149.2 2.105 3.214 5.1 4.508.712.307 1.269.491 1.702.628.716.227 1.366.195 1.88.119.574-.086 1.767-.723 2.016-1.42.248-.696.248-1.294.174-1.419-.075-.124-.273-.2-.572-.348v.003z"}})])
          )
        }
      }
    